import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconFlagSvg } from "./IconFlagSvg.mjs";
const IconFlag = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconFlagSvg, ...svgProps }) });
export {
  IconFlag
};
